import log from 'salvo-lite/log'

class OpenChat {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._elem.addEventListener('click', e => {
            document.querySelector('.olark-launch-button').click()
        })
    }
}

export default OpenChat



// WEBPACK FOOTER //
// ./src/resources/scripts/components/OpenChat.js